<style lang="scss" scoped>
.slide-4 {
  background-image: url("../../../assets/module4/slide4/bg-01.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 161px;
  padding-left: 141px;
  height: calc(100% - 161px);
  padding-right: 50px;
  display: flex;
}
h1 {
  font-size: 50px;
  color: #c5d43b;
  line-height: 60px;
  margin-bottom: 50px;
  &:last-of-type {
    color: #f8dc61;
  }
}
.content {
  max-width: 791px;
}
.play {
  transition: all 0.2s ease-out;
  position: absolute;
  width: 400px;
  display: block;
  right: 288px;
  top: 650px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
video {
  outline: none !important;
  position: absolute;
  top: 133px;
  right: 79px;
  z-index: 9;
  width: 817px;
  height: 457px;
  border-radius: 23px;
}
</style>

<template>
  <div class="slide-4">
    <video
      v-if="showVideo"
      :src="videoURL"
      autoplay
      controls
      ref="video"
    ></video>
    <transition name="fadeLeft" appear>
      <div class="content" v-if="slideIndex == 3">
        <h1>
          I must admit that I do get a bit carried away from time to time when
          my favorite song comes on to the radio.
        </h1>
        <h1>Let me show you what I mean.</h1>
      </div>
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module4/slide4/video-01.png"
        class="chars"
      />
    </transition>
    <a href="" class="play " @click.prevent="playVideo(videoID)">
      <transition name="scale" appear>
        <img
          class="delay-1"
          v-show="slideIndex == 3"
          src="@/assets/module2/slide5/play_button.svg"
        />
      </transition>
    </a>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_4_video_1?.hd_large?.url ||
        "https://player.vimeo.com/external/357339248.hd.mp4?s=b2c035e8d89bb770f8652bec0d28e08e3424e554&profile_id=175",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_4_video_1?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
